import { RegistrationError } from '@montugroup/contracts-warehousing-api';

export const ERROR_MESSAGES = {
  [RegistrationError.DuplicateEmail]: 'An account with this email already exists.',
};

export const VALIDATION_MESSAGES = {
  REQUIRED: 'Field is required',
  CANNOT_BE_EMPTY: 'Field cannot be empty',
  PHARMACY_ADDRESS_REQUIRED: 'Pharmacy address is required',
  PHARMACY_ADDRESS_CANNOT_BE_EMPTY: 'Pharmacy address cannot be empty',
};

export const STATUS_TEXT_UNAVAILABLE = 'Service Unavailable';
export const ACCESS_DENIED = 'Access denied';
export const ACCESS_DENIED_MESSAGE = `Sorry, your account has been suspended. You won't be able to view our catalog or place any orders at the moment. If this is an error or if you need assistance, please contact our support team at 03 7003 8214 for further information.`;

// Acceptable error page types used in Error Boundaries
export const ErrorPageTypes = {
  ARTICLE: 'article',
  COLLECTION: 'collection',
  ORDER: 'order',
  PAGE: 'page',
  PRODUCT: 'product',
  RETURN: 'return',
  SHIPMENT: 'shipment',
} as const;

// Type representing the acceptable error page types
export type ErrorPageType = (typeof ErrorPageTypes)[keyof typeof ErrorPageTypes];
